document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('das-tuning-searchTrigger');

  if (!trigger) return;

  trigger.addEventListener('click', () => {
    const searchModal = document.querySelector('search-modal');

    if (searchModal && typeof searchModal.open === 'function') {
      searchModal.open();
      return;
    }

    // Fallback if modal is unavailable
    window.location.href = '/search';
  });
});
